// Shared "awaiting admin review" / "revoked" card — used everywhere an
// account-type application (Agent, Fleet Owner, B2B, Corporate, Rider KYC,
// profile change requests) is waiting on or was denied admin action, so the
// experience reads the same regardless of which application it is.
export default function ApplicationStatusCard({ status = "pending", title, description, footer }) {
  const isPending = status === "pending";
  return (
    <div className="delivery-card" style={{ maxWidth: "520px", margin: "0 auto", textAlign: "center" }}>
      <span style={{ fontSize: "48px" }}>{isPending ? "⏳" : "🔒"}</span>
      <h3 style={{ marginTop: "8px", color: isPending ? undefined : "var(--danger)" }}>{title}</h3>
      <p style={{ color: "var(--text-muted)", fontSize: "14px", marginBottom: footer ? "16px" : 0 }}>{description}</p>
      {footer}
    </div>
  );
}
